var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ee-switch"
  }, [_c('span', {
    staticClass: "ee-switch__item",
    class: {
      'is-active': _vm.value === _vm.falseValue
    },
    on: {
      "click": function($event) {
        _vm.handleChange(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.falseText))]), _vm._v(" "), _c('span', {
    staticClass: "ee-switch__item",
    class: {
      'is-active': _vm.value === _vm.trueValue
    },
    on: {
      "click": function($event) {
        _vm.handleChange(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.trueText))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a56fe76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/switch/Switch.vue
// module id = 567
// module chunks = 13